module.exports = __webpack_public_path__ + "static/media/c3bannerModul2_small.454999ca.jpg";